// extracted by mini-css-extract-plugin
module.exports = {"error":"conditional-issue-text_error__1XZSe","warning":"conditional-issue-text_warning__153qn","errorWrapper":"conditional-issue-text_errorWrapper__2nJej"};